var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{staticClass:"card"},[_c('h3',[_vm._v("Цены")]),_c('Price',{attrs:{"data":_vm.data.booking.prices},on:{"update:data":function($event){return _vm.$set(_vm.data.booking, "prices", $event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }